import { Link } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@awesome.me/kit-2be97ecbd6/icons/classic/solid';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { DateTime } from 'luxon';

import StatusIcon from './StatusIcon.jsx';
import { FLOOD_LEVEL_MINOR, FLOOD_LEVEL_MODERATE, FLOOD_LEVEL_MAJOR } from '../helpers/SiteDataConst.js';

const ALERT_TYPE_WARNING = 'warning';
const ALERT_TYPE_FLOOD_SEVERITY = [
  FLOOD_LEVEL_MINOR,
  FLOOD_LEVEL_MODERATE,
  FLOOD_LEVEL_MAJOR,
]

import styles from './RiverSummary.module.css';
import Placeholder from './Placeholder.jsx';

function RiverSummary({river, title, subtitle, link}) {
  const {t} = useTranslation();
  const riverAlerts = river ? determineRiverAlerts(river) : [];

  return (
    <div className={styles.RiverSummaryContainer}>
      <div className={styles.RiverSummaryHeader}>
        <h4>{title}</h4>
        {subtitle && <div className={styles.RiverSummarySubtitle}>{subtitle}</div>}
      </div>
      <div className={styles.RiverSummaryAlerts}>
        <Placeholder ready={river} className={styles.RiverSummaryAlertPlaceholder}>
          {riverAlerts.length == 0 && <div className={clsx(styles.RiverSummaryAlert, styles.RiverSummaryAlertMuted)}>{t('river_summary.alerts.none')}</div>}
          {riverAlerts.map(alert => {
            let linkFragment = '';
            if (alert.site) {linkFragment = `#${alert.site}`;}
            if (alert.type == 'warning') {linkFragment = `#warnings`;}

            return (
            <Link className={clsx(styles.RiverSummaryAlert, styles[`RiverSummaryAlert--${alert.type}`])} key={alert} to={`${link}${linkFragment}`}>
              <StatusIcon status={alert.type} className={styles.RiverSummaryAlertIcon} />
              <span>{t(`river_summary.alerts.${alert.type}`)}</span>
            </Link>
          )})}
        </Placeholder>
      </div>
      <div className={styles.RiverSummaryAction}>
        <Link to={link} className={clsx(styles.RiverSummaryBtn, 'btn',  'btn-link')}>
          View River Levels<FontAwesomeIcon icon={faArrowRight} className={styles.RiverSummaryBtnIcon} />
        </Link>
      </div>
    </div>
  );
}

const determineRiverAlerts = (river) => {
  let alerts = [];
  if (river.warning && DateTime.fromISO(river.warning?.validity_end_timestamp) > DateTime.now()) {
    alerts.push({type: ALERT_TYPE_WARNING});
  }

  const maxFloodState = river.siteSummary.reduce((maxFloodStateAlert, site) => {
    if (site.state?.floodState) {
      if (maxFloodStateAlert === undefined || ALERT_TYPE_FLOOD_SEVERITY.indexOf(site.state.floodState) > ALERT_TYPE_FLOOD_SEVERITY.indexOf(maxFloodStateAlert.type)) {
        return {type: site.state.floodState, site: site.id};
      }
    }

    return maxFloodStateAlert;
  }, undefined)

  if (maxFloodState) {
    alerts.push(maxFloodState);
  }

  return alerts;
}

export default RiverSummary
